goog.provide('el8.app.settings.patientForms');
goog.require('el8.app.settings.reactTab');

el8.app.settings.patientForms = el8.app.settings.reactTab({
    containerId: 'patient-forms',
    renderFnName: 'renderPatientForms',
    props: {
      practiceId: el8Globals.PRACTICE_ID
    }
});
